<template>
    <w-flex wrap id="Monitoring" >
            <div ><span class="xs8 headline text-left pl7"> Monitoring Map&nbsp;</span> <state-info :alignment="'right'" :infos="statusInfoMapLegend()"></state-info></div>

        <div class="xs12 pa2 fill-height">
            <MapComponent v-if="isMounted" class="xs12" :startzoom="view.zoom"
                :positions="stationsMapStore.state.mapElements" :viewCenter="view.center"
                @changeView="(val) => changeView(val)" />
        </div>
    </w-flex>
</template>

<script>
import { stationStore } from "@/modules/monitoring/store/monitorig.js";
import { monitoringStatusClass } from "@/utils/status";
import { stationsMapStore } from "../store/monitoring-map-withpages";
import {
    defineAsyncComponent,
    onMounted,
    reactive,
    ref,
    onUnmounted
} from "vue";
import router from "@/router/index.js";
import "@mdi/font/css/materialdesignicons.min.css";
import { watch } from "vue";
import { optionsStore } from "@/store/options.js";
import StateInfo from '../../monitoring/components/StateInfo.vue';
import {statusInfoNtripExtended, statusInfoMapLegend } from '@/utils/status';

var MapComponent = defineAsyncComponent(() => import("../components/Map-elaborated.vue"));
const map = window.__env.defaults && window.__env.defaults.map ? window.__env.defaults.map : {
    "page_size": 5,
    "map_delay_ms": 1000,
    "map_center": []
};
const map_center = map.map_center ? map.map_center : [45, 10];
const page_size = map.page_size ? map.page_size : 2;
const map_delay = map.map_delay_ms ? map.map_delay_ms : 1000
const use_cached = map.used_cached ? map.used_cached : true

export default {
    name: "MonitoringMapView",
    components: { MapComponent, StateInfo },
    setup: () => {
        var lastRefresh = ref(new Date());
        const isMounted = ref(false);
        var timer = null;
        var view = reactive({ topLeft: null, bottomRight: null, center: [] })
        var loading = false
        const statuses = statusInfoNtripExtended().map((state)=>{
        return { label: state.name, value: state.id }
      });

        // let stationsList = reactive([]);
        let stations = reactive([]);
        function timeformatt(dateSec) {
            if (!dateSec) {
                return null;
            }
            //TODO get current time zone
            return new Intl.DateTimeFormat("it-IT", {
                hour: "2-digit",
                minute: "2-digit",
                second: "2-digit",
            }).format(dateSec * 1000);
        }

        async function getCurrentLocation() {

            let backup = optionsStore.state.position && optionsStore.state.position.length > 0 ? optionsStore.state.position : map_center
            console.log("Trigger current position backup ", optionsStore.state.position, backup);
            if (view.center.length == 0) {
                console.log("Trigger current position backup use because ", view.center);
                view.center = backup
                view.zoom=optionsStore.state.mapzoom
            }
            isMounted.value = true
            let position = await optionsStore.getCurrentLocation().then(res => {
                if (res && res.length > 0 && view.center && view.center.length == 0) {
                    console.log("Trigger reset view.center with new current position", view.center);
                    return res;
                } else {
                    return backup
                }
            }).catch(() => map_center)
            console.log("POSITION", position);
            return position
        }
        onMounted(async () => {
            console.log("Trigger mount page");
            loading = true;
            clearInterval(timer);
            stationsMapStore.state.params.size = page_size
            stationsMapStore.state.mapElements = []
            stationsMapStore.initEmit((selection) => {
                stationsMapStore.state.recallPosition.active = true
                openDetail(selection)
            })
            if (stationsMapStore.state.recallPosition.active && stationsMapStore.state.recallPosition.center) {
                console.log("recall position",  stationsMapStore.state.recallPosition.center);
                view.zoom = stationsMapStore.state.recallPosition.zoom
                view.center = stationsMapStore.state.recallPosition.center;
                stationsMapStore.state.recallPosition.active = false
  
                isMounted.value = true;
            } else {
                console.log("current position");
                isMounted.value = getCurrentLocation().then((result) => {
                    view.center = result;
                    
                    return Promise.resolve(true);
                })
            }

            loading = false;

        });

        onUnmounted(() => {
            clearInterval(timer);
            stationsMapStore.state.mapElements = []
        });

        function conditionalClass(value) {
            return monitoringStatusClass(value, "px2 text-center")
        }

        function openDetail(selection) {
            console.log(selection.item);
            let station = selection.item;
            localStorage.setItem("baseStationId", station.baseStation);
            stationStore.setStation(station);
            router.push({
                name: `MonitoringStation`,
                params: {
                    basestation: station.baseStation,
                },
                props: {
                    station: selection,
                },
            });
        }
        // 3# the emit of the change bring the necessati bound infirmation to load the baseStations
        function changeView(value) {
            view.topLeft = value.topLeft
            view.bottomRight = value.bottomRight

            stationsMapStore.setView(value)
            console.log("Trigger Change view", timer);
            clearTimeout(timer);

            console.log("data retrived", value);
            timer = setTimeout(() => load(), map_delay)
        }
        function load() {
            if (view.topLeft.length > 0
                && view.bottomRight.length > 0) {
                console.log("LOAD");
                loading = true;
                if (use_cached) {
                    console.log("LOAD cachecd");

                    loading = stationsMapStore.loadNewMap().then(() => {
                        // console.log("elemens"+stationsMapStore.state.mapElements);
                        return Promise.resolve(false);
                    });
                } else {
                    loading = stationsMapStore.getMonitoringStations().then(() => {
                        return Promise.resolve(false);
                    })
                }
            }
        }

        watch(
            () => stationsMapStore.state.data,
            (data) => {
                console.log(data);
            }
        );

        watch(
            () => stationsMapStore.state.loading,
            () => {
                loading = true;
            }
        );
        return {
            statusInfoNtripExtended,
            statusInfoMapLegend,
            statuses,
            router,
            stationsMapStore,
            stations,
            // stationsList,
            stationsStore: stationsMapStore,
            opacity: 0.3,
            // getStationsStat,
            openDetail,
            conditionalClass,
            persistent: false,
            persistentNoAnimation: false,
            //
            lastRefresh,
            timeformatt,
            //
            //getPositions,
            isMounted,
            view,
            getCurrentLocation,
            loading,
            changeView,
            optionsStore
        };
    },
};
</script>

<style>
/* dropdown menu avoid being covered by map  */
.w-menu.w-select__menu.w-menu--bottom.w-menu--align-left {
    z-index: 2000;
}
</style>